export const BreadcrumbsTextVariant = {
  DEFAULT: 'default',
  LARGE: 'large',
};
